var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconhome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 11.4,
    height: 11.4,
    viewBox: "0 0 11.4 11.4",
    style: {
      enableBackground: "new 0 0 11.4 11.4"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#606060;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.1,5.5c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0L10,5.3v3.8c0,0.8-0.7,1.5-1.5,1.5H3 c-0.8,0-1.5-0.7-1.5-1.5V5.3L0.7,5.9c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1-0.1-0.3,0-0.4l5.2-4.6c0.1-0.1,0.3-0.1,0.4,0L11.1,5.5z M3,10 h1.2V6.9c0-0.3,0.3-0.6,0.6-0.6h1.8c0.3,0,0.6,0.3,0.6,0.6V10h1.2C9,10,9.4,9.6,9.4,9.1V4.8L5.7,1.5L2.1,4.8v4.3 C2.1,9.6,2.5,10,3,10z M4.8,10h1.8V6.9H4.8V10z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconhome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.home.91c88d48a96984966d8c3603fdc6fbd1.svg";